import { uniquenessCheck, API_ROOT } from '../../supplementary_components/requests';
import {possibleEquipmentYears, generateRandomString} from "../../supplementary_components/supplementaryMethods";
import { purchaseTypeAddColumn } from "../reports/purchaseTypeOptions";



export const TRUCK_ADD_CONF = {

    formAccessLevel: { key: 'TRUCKS', level: 'MANAGE' },
    formTitle: "Add Truck",
    name: 'addTruckForm',
    addLink: API_ROOT+'trucks/add',
    successMessage:'Truck was added',
    columns: [
        {
            label: "Truck Type",
            name: "truckType",
            type: "select",
            dataset: ["Company", "Owner", "Lease"],
            onChange: (event) => {
                const owner = event.target.value === 'Owner';
                let form = event.target;
                while (form && form.tagName !== 'FORM') form = form.parentNode;
                const field = form?.querySelector('[name="purchaseType"]');
                if (!field) return;
                field.disabled = owner;
                field.parentNode.style.display = owner ? 'none' : 'block';
                if (owner) field.value = '';
            },
            // processBeforeSending : val => {
            //     return (val === "Company Truck");
            // },
        },
        {
            label: "Truck Number",
            name: "truckNumber",
            mandatory: true,
            autoComplete:"off",
            checks : [
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue){
                        if(column.defaultValue() === value){
                            resolve(null);
                            return
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"trucks/exists", "truckNumber", value, "Truck with this number already exists"));
                }),
            ]
            // filters: [
            //     val => {return val.replace(/[0-9]/g, '')}
            // ]
        },
        {
            label: "Vin",
            name: "vin",
            mandatory: true,
            autoComplete:"off",
            checks : [
                (value) => {
                    return value.length !== 17 ? 'Vin number must be 17 characters' : null;
                },
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue){
                        if(column.defaultValue() === value){
                            resolve(null);
                            return
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"trucks/exists", "vin", value, "Truck with this vin number already exists", "vin number"));
                }),
            ],
        },
        {
            label: "Make",
            name: "make",
            mandatory: true,
        },
        {
            label: "Model",
            autoComplete: "off",
            name: "model",
            mandatory: true,
        },
        {
            label: "License Plate",
            name: "licensePlate",
            mandatory: true,
            spaceAllowed: true,
            required: true,
            defaultValue: ()=>{return `TEMP(${generateRandomString(3)})`},
            checks : [
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue){
                        if(column.defaultValue() === value){
                            resolve(null);
                            return
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"trucks/exists", "licensePlate", value, "Truck with this license plate number already exists", "license plate number"));
                }),
            ],
        
        },
        {
            label: "Year",
            type: "select",
            name: "year",
            dataset: possibleEquipmentYears(),
            processBeforeSending : val => {
                return (parseInt(val));
            }
        },
        purchaseTypeAddColumn(),
        
    ]
}